import React, { Component } from 'react';
import { withDomains, RESTExecutor } from '../../../lib/domain';
import { Spin } from 'antd';
import HookAddEdit from './addedit';


class HookEdit extends Component {
  constructor(props) {
    super(props)
  
    this.state = {
       edit_data:{},
       edit_id:this.props.config_id,
       loaded:false
    };

    this.get_detail=RESTExecutor.detail().config({
      label:'detail',
  }).forId(this.props.config_id).callbacks((success)=>{
      this.setState({
          edit_data:success?.result??{},
          loaded:true
      })
  }).connect(props.domains.hook);


    if(this.props.config_id){
   this.get_detail.execute()
  }   
  };
  
render() {
    const {loaded,edit_data,edit_id}=this.state;
    if(!loaded){
        return <center><Spin/></center>
    }

  return (
    <div> 
        <HookAddEdit 
        key={`-${edit_id}`}
        edit_id={edit_id}
        edit_data={edit_data}
        onRefresh={()=>{
            this.get_detail.execute()
        }}

        onClose={this.props.onClose}
        onRefreshClose={this.props.onRefreshClose}
        />
      </div>
  );
}

componentDidUpdate = (prevProps) => {
  if ( this.props.config_id !== prevProps.config_id) {

      this.setState({
          edit_id: this.props.config_id,
          loaded:false
      })
      this.get_detail.forId(this.props.config_id).execute();


  };
}
}
export default withDomains(HookEdit,'hook');
